import React, { useEffect, useState } from 'react'
import isNull from '../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Modal, ModalBody } from "react-bootstrap";
import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { useSelector } from 'react-redux';
import SuperICDandCPTSearch from '../../../../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';
// import DateValidator from '../../../../../../../../../../../utils/DateValidator';
import AddNewDiagnosis from '../../../../../../../../../../Setup/Coding/DiagnosisCode/AddNewDiagnosis';
import { isAfter, parse, format, isBefore } from 'date-fns';
import SuperSearchMultipleClient from '../../../../../../../../../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';

const AddNewProblem = ({ ...props }) => {
    let { patientID } = props;
    console.log("IsDeleteAllowed", props, props?.IsDeleteAllowed)
    let { IsEditAllowed } = props;
    // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true)).data?.id;
    const isExistingSOAPProblem = props?.problemModal?.DiagnosisCodeID;
    const { isOpenProblems, onClose, onDeleteProblems } = { ...props }
    const API_URL = enumUtil.controller.General
    const API_URL_Claim = enumUtil.controller.Claim
    const API_URL_Patient = enumUtil.controller.Patient
    let RecentICDs = useSelector(state => state.CodesDropDownReducer.RecentICD)
    let Problems_Modal = {
        DiagnosisCode: "",
        DiagnosisCodeID: "",
        Acuity: "Undefined",
        StartDate: "",
        EndDate: "",
        IsEncounter: "false",
        Notes: "",
        SnomedCode: "",
        Description: "",
        MarkAsPrimary: "false"
    }
    let valModal = {}
    let ValidationModal = {
        DiagnosisCodeIDVal: "",
        // StartDateVal: "",
    }

    let validationModalDate = {}
    let dateValidation = {
        DateVal: '',
    }

    const [isOpenNewDiagnosis, setisOpenNewDiagnosis] = useState(false)
    const [icdCode, setIcdCode] = useState()
    const [ActiveICDName, setActiveICDName] = useState('')
    const [error, setError] = useState(dateValidation);
    const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
    const [isProblemSelected, setIsProblemSelected] = useState(false);
    const [isEdit, setIsEdit] = useState(true)
    const [problemsID, setProblemsID] = useState();
    const [problemsValidationModal, setProblemsValidationModal] = useState(ValidationModal)
    const [problemsSaveUpdateModal, setProblemsSaveUpdateModal] = useState({})
    const [mainProblemsModal, setMainProblemsModal] = useState(Problems_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [onProblemsSaved, setOnProblemsSaved] = useState(false)
    const [del, setDel] = useState(false)
    const [searchDropdown, setSearchDropdown] = useState(false);
    const [is, setIs] = useState(false);
    const [dsm5CriteriaOptions, setDsm5CriteriaOptions] = useState([]);
    const [selectedDSM5Criteria, setSelectedDSM5Criteria] = useState([]);
    console.log("AddNewProblem", props)
    const [problemsBody, setProblemsBody] = useState({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": '' })

    const handleProblemsChange = (e) => {
        setIs(false)
        setMainProblemsModal(prev => ({ ...prev, DiagnosisCode: e.target.value }));
        setProblemsBody({ "TableName": enumUtil.enumAPITableName.Diagnosis, "SearchParam": e.target.value })
    }
    useEffect(() => {
        // setPracticeID(PracticeID)
        if (props.problemsID != null) {
            setDel(true)
            setProblemsID(props.problemsID)
        } else {
            if (!onProblemsSaved) {
                setProblemsID(0);
                setDel(false)
            } else {
                setDel(true)
            }
        }
        if (!isNull(problemsID) && !isExistingSOAPProblem) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": problemsID,
                "TableName": enumUtil.enumAPITableName.PatientProblemList
            }).then((response) => {
                setIsLoading(false);
                setIsEdit(false);
                setIsProblemSelected(true);
                setMainProblemsModal(response)
                const mappedSelected = (response?.DSM5Criteria || []).map(item => ({
                    ...item,
                    value: item.DSM5CriteriaID,
                    display: `${item.CriteriaText}`,
                }));
                setSelectedDSM5Criteria(mappedSelected);
                fetchDSM5Criteria(response?.DiagnosisCodeID, response?.DiagnosisCode);
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [problemsID])

    useEffect(() => {
        if (props?.selectedDiagnosisValue) {
            console.log("selectedDiagnosisValueAddProblemsAddProblemss")
            handleSelectedData(props?.selectedDiagnosisValue, "DiagnosisCode", 'server');
        } else {
            setMainProblemsModal(Problems_Modal)
            // console.log("props.problemsID",props.problemsID)
            if (!isNull(props.problemsID)) {
                // setProblemsID(props.problemsID)
                if (props?.problemModal?.DiagnosisCodeID) {
                    setMainProblemsModal({
                        ...props?.problemModal,
                        DiagnosisCodeID: props?.problemModal?.DiagnosisCodeID,
                        DiagnosisCode: props?.problemModal?.DiagnosisCode,
                        EncounterProblemID: props?.problemModal?.EncounterProblemID,
                        PatientProblemListID: props?.problemModal?.PatientProblemListID,
                        StartDate: props?.problemModal?.StartDate,
                        Description: props?.problemModal?.Description,
                        Notes: props?.problemModal?.ProblemNotes,
                    })
                    if (props?.problemModal?.DiagnosisCodeID) {
                        setIsEdit(false);
                        setIsProblemSelected(true);
                        setIs(true);
                    }
                }
            } else {
                // console.log("props.problemsID ELSE", props?.problemModal)
                setMainProblemsModal({
                    ...Problems_Modal,
                    ...props?.problemModal,
                    DiagnosisCodeID: props?.problemModal?.DiagnosisCodeID,
                    DiagnosisCode: props?.problemModal?.DiagnosisCode,
                });
                if (props?.problemModal?.DiagnosisCodeID) {
                    setIsEdit(false);
                    setIsProblemSelected(true);
                    setIs(true);
                }
            }
        }
    }, [props?.problemsID]);

    const ProblemsValidation = async () => {
        console.log("DiagnosisCodeID", mainProblemsModal.DiagnosisCodeID)
        let ValidationModal = {
            // StartDateVal: FormValidator(
            //     mainProblemsModal.StartDate,
            //     enumUtil.enumValidationType.Required,
            //     'Start Date',
            // ),
            DiagnosisCodeIDVal: FormValidator(
                mainProblemsModal.DiagnosisCode,
                enumUtil.enumValidationType.Required,
                'Problem',
            ),

        }
        await setProblemsValidationModal(ValidationModal)
        valModal = ValidationModal
    }

    const DateValidator = (startDate, endDate, type) => {
        if (type === enumUtil.enumValidationType.StartEndDate) {
            if (!isNull(startDate)) {
                const parsedStartDate = parse(startDate, 'MM/dd/yyyy', new Date());
                const parsedEndDate = parse(endDate, 'MM/dd/yyyy', new Date());
                if (isBefore(parsedEndDate, parsedStartDate)) {
                    return (
                        <div className="invalid-feedback tool_tip d-flex align-items-center gap-1 GreaterDate" style={{ display: "block" }}>
                            <i className="bi bi-info-circle-fill fs-10"></i>
                            <p className="fs-9 text-white text">Start Date cannot be greater than end date</p>
                        </div>
                    )
                }
            }
            return '';
        }

    }

    const DateComparisonValidation = async () => {
        let ValidationModal = {
            DateVal: DateValidator(
                mainProblemsModal.StartDate,
                mainProblemsModal.EndDate,
                enumUtil.enumValidationType.StartEndDate,
                'Date',
            ),
        }
        await setError(ValidationModal)
        validationModalDate = ValidationModal
    };

    const addNewProblem = () => {
        props.setProblemsID(null);
        setProblemsID(null)
        handleClear();
    }
    const handleSaveProblems = async (type) => {
        if (!IsEditAllowed) return;
        await DateComparisonValidation();
        await ProblemsValidation();
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        let validation1 = FormValidator([validationModalDate], enumUtil.enumValidationType.NullCheck)
        if (validation || validation1) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            let saveModal = {
                TableName: enumUtil.enumAPITableName.PatientProblemList,
                ID: problemsID,
                data: {
                    PatientID: String(patientID),
                    Acuity: mainProblemsModal.Acuity,
                    ...problemsSaveUpdateModal,
                },
                DSM5CriteriaIDs: selectedDSM5Criteria.map(c => c.value ?? c.DSM5CriteriaID),
            };

            if (props?.isOpenedFrom === 'SOAP') {
                // console.log("isOpenedFrom Problem", props?.isOpenedFrom, saveModal);
                const clientRecordIDExist = props?.problemModal?.recordNoClient;
                let probID = problemsID === 0 ? "" : problemsID;

                // 🔁 Update EncounterProblem in Additional Info (like EncounterDocument)
                props?.setAssessmentData(prev => {
                    const encounterList = [...(prev.EncounterProblem || [])];
                    const encounterLength = encounterList.length;

                    const idExist = encounterList.some(
                        item => item.PatientProblemListID === problemsID
                    );

                    const mainViewObj = {
                        recordNoClient: String(
                            idExist
                                ? Number(props?.problemModal?.recordNoClient) || 0
                                : encounterLength + 1
                        ),
                        ...props?.problemModal,
                        ...problemsSaveUpdateModal,
                        EncounterProblemID: props?.problemModal?.EncounterProblemID ?? "",
                        PatientProblemListID: probID ?? "",
                        ...(problemsSaveUpdateModal.ProblemID ? { ProblemID: problemsSaveUpdateModal.ProblemID } : {}),
                    };

                    let updatedList = [...encounterList];

                    if (clientRecordIDExist) {
                        const index = updatedList.findIndex(
                            item => String(item.recordNoClient) === String(clientRecordIDExist)
                        );
                        if (index !== -1) {
                            updatedList[index] = { ...mainViewObj };
                        } else {
                            updatedList.push(mainViewObj);
                        }

                    } else if (isNull(problemsID)) {
                        // ✅ New record, but check if DiagnosisCodeID already exists
                        const diagnosisCode = mainViewObj.DiagnosisCodeID;
                        const existingIndex = updatedList.findIndex(
                            item => item.DiagnosisCodeID === diagnosisCode
                        );

                        if (existingIndex !== -1) {
                            // Replace existing record with same DiagnosisCodeID
                            updatedList[existingIndex] = { ...mainViewObj };
                        } else {
                            updatedList.push(mainViewObj);
                        }

                    } else if (idExist) {
                        updatedList = updatedList.map(item =>
                            item.PatientProblemListID === probID ? { ...mainViewObj } : item
                        );
                    } else {
                        updatedList.push(mainViewObj);
                    }

                    return {
                        ...prev,
                        EncounterProblem: updatedList
                    };
                });

                // 💾 SaveProblemsData — do not include recordNoClient
                props?.setSaveProblemsData(prev => {
                    const idExist = prev.some(item => item.PatientProblemListID === problemsID);
                    const saveData = {
                        ...props?.problemModal,
                        EncounterProblemID: props?.problemModal?.EncounterProblemID ?? "",
                        PatientProblemListID: probID ?? "",
                        PatientID: String(patientID),
                        Acuity: mainProblemsModal.Acuity,
                        ...problemsSaveUpdateModal,
                    };

                    // Remove `recordNoClient` if present
                    delete saveData.recordNoClient;

                    return isNull(problemsID)
                        ? (prev.some(item => item.DiagnosisCodeID === saveData.DiagnosisCodeID)
                            ? prev.map(item =>
                                item.DiagnosisCodeID === saveData.DiagnosisCodeID ? { ...saveData } : item
                            )
                            : [...prev, saveData]
                        )
                        : (idExist
                            ? prev.map(item =>
                                item.PatientProblemListID === problemsID ? { ...saveData } : item
                            )
                            : [...prev, saveData]
                        );
                });

                onClose();
                return;
            }

            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setProblemsID(response.id)
                        props?.setIsRecordSaved?.(true);
                        props?.setIsRecordSavedType?.('Problems');
                        setOnProblemsSaved(true);
                        setSearchDropdown(false)
                        if (type === "Add Another") {
                            addNewProblem();
                        } else {
                            onClose();
                        }
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }

    const ProblemName = () => {
        return (
            <p className="heading">Add New Problem</p>
        )
    }

    const handleClear = () => {
        setMainProblemsModal(Problems_Modal);
        setProblemsSaveUpdateModal({});
        setIsEdit(true);
        setIsProblemSelected(false);
        setDsm5CriteriaOptions([]);
        setSelectedDSM5Criteria([]);
    }

    const handleSetCheckbox = (e) => {
        let { name, checked } = e.target
        let modal = { ...mainProblemsModal };
        let saveModal = { ...problemsSaveUpdateModal }
        modal[name] = String(checked);
        setMainProblemsModal(modal)
        for (var property in Problems_Modal) {
            if (name === property) {
                saveModal[name] = String(checked);
            }
        }
        setProblemsSaveUpdateModal(saveModal)
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        let modal = { ...mainProblemsModal };
        let saveModal = { ...problemsSaveUpdateModal }
        if (name === 'MarkAsPrimary') {
            const checked = e.target.checked ? "true" : "false";
            modal[name] = checked
        } else {
            modal[name] = value
        }
        setMainProblemsModal(modal)
        for (var property in Problems_Modal) {
            if (name === property) {
                if (name === 'MarkAsPrimary') {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setProblemsSaveUpdateModal(saveModal)
    }
    const handleDateChange = (date, type) => {
        var FormatedDate = date
        let modal = { ...mainProblemsModal };
        let saveModal = { ...problemsSaveUpdateModal }
        modal[type] = FormatedDate
        setMainProblemsModal(modal)
        for (var property in Problems_Modal) {
            if (type === property) {
                saveModal[type] = FormatedDate
            }
        }
        setProblemsSaveUpdateModal(saveModal)
    }

    const handleClearDiagnosisCode = () => {
        let name = 'DiagnosisCode';
        let modal = { ...mainProblemsModal };
        modal[name] = ''
        problemsSaveUpdateModal[name] = ''
        problemsSaveUpdateModal[name + 'ID'] = "";
        if (name === 'DiagnosisCode') {
            setIsProblemSelected(false);
        }
        setMainProblemsModal(modal)
        setProblemsSaveUpdateModal(problemsSaveUpdateModal)
        setDsm5CriteriaOptions([]);
        setSelectedDSM5Criteria([]);
    }

    const handleSelectedData = (selectedData, name, type, mode) => {
        setIs(true)
        let modal = { ...mainProblemsModal };
        if (type === 'client' && !isNull(selectedData)) {
        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'DiagnosisCode') {
                modal[name] = selectedData.display
                modal['Description'] = selectedData.Description;
                problemsSaveUpdateModal[name] = selectedData.display + "";
                problemsSaveUpdateModal[name + 'ID'] = selectedData.value + "";

                setSelectedDSM5Criteria([]);
                fetchDSM5Criteria(selectedData.value, selectedData.display);

                if (props?.isOpenedFrom === 'SOAP') {
                    console.log("selectedData", selectedData)
                    if (selectedData.Acuity) {
                        modal['Acuity'] = selectedData.Acuity;
                        problemsSaveUpdateModal['Acuity'] = selectedData.Acuity + "";
                    }
                    if (selectedData.StartDate) {
                        modal['StartDate'] = selectedData.StartDate;
                        problemsSaveUpdateModal['StartDate'] = selectedData.StartDate + "";
                    }
                    if (selectedData.Notes) {
                        modal['Notes'] = selectedData.Notes;
                        problemsSaveUpdateModal['Notes'] = selectedData.Notes + "";
                    }
                    if (selectedData.EndDate) {
                        modal['EndDate'] = selectedData.EndDate;
                        problemsSaveUpdateModal['EndDate'] = selectedData.EndDate + "";
                    }
                    if (selectedData.Description) {
                        modal['Description'] = selectedData.Description;
                        problemsSaveUpdateModal['Description'] = selectedData.Description + "";
                    }
                    if (selectedData.FullDescription) {
                        modal['FullDescription'] = selectedData.FullDescription;
                        problemsSaveUpdateModal['FullDescription'] = selectedData.FullDescription + "";
                    }
                }

                setIsEdit(false);
                setIsProblemSelected(true);
            }
        } else {
            modal[name] = ''
            problemsSaveUpdateModal[name] = ''
            problemsSaveUpdateModal[name + 'ID'] = "";
            if (name === 'DiagnosisCode') {
                setIsProblemSelected(false);
            }
        }
        props?.setSelectedDiagnosisValue?.('');
        setMainProblemsModal(modal)
        return selectedData
    }

    const handleDeleteModal = () => {
        setisOpenDeleteAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenDeleteAlert(false);
    }
    const onDelete = () => {
        props?.setIsRecordSaved?.(true);
        props?.setIsRecordSavedType?.('Problems');
        setisOpenDeleteAlert(false);
        onClose();
    }

    let DeleteConfirmation = "";
    if (isOpenDeleteAlert) {
        DeleteConfirmation = (
            <DeleteConfirmatiom
                isOpenAlert={isOpenDeleteAlert}
                hideReason={true}
                API_URL={API_URL}
                TableName={enumUtil.enumAPITableName.PatientProblemList}
                ID={String(problemsID)}
                onCloseDelete={onCloseDelete}
                onClose={onDelete}
            />
        );
    }
    let DeletePopup = "";
    if (del) {
        DeletePopup = (
            <button
                className={
                    props?.IsDeleteAllowed
                        ?
                        "btn-icon-transparent" : "btn-icon-transparent delete-btn-disabled"
                } onClick={handleDeleteModal}>
                <span className="icon"><i className="icon-delete"></i></span>
                <span className="title">Delete</span>
            </button>
        );
    }

    const handleAddNewICD = (searchValue, name) => {
        setActiveICDName(name)
        setIcdCode(searchValue)
        setisOpenNewDiagnosis(true)
    }

    const handleCloseICD = () => {
        setisOpenNewDiagnosis(false)
    }

    const handleOnSaveICD = (selectedData) => {
        if (!isNull(ActiveICDName)) {
            handleSelectedData(selectedData, ActiveICDName, 'server')
        }
    }

    let NewICDPopup = ''
    if (isOpenNewDiagnosis) {
        NewICDPopup = <AddNewDiagnosis isOpenDiagnosis={isOpenNewDiagnosis} onClose={handleCloseICD} Diagnosisvalue={icdCode} onDeleteProcedure={handleCloseICD} onDeleteDiagnosis={handleCloseICD} IsOpen={true} onICDSave={handleOnSaveICD} />
    }

    const fetchDSM5Criteria = (diagnosisCodeID, diagnosisCode) => {
        if (isNull(diagnosisCodeID)) {
            setDsm5CriteriaOptions([]);
            setSelectedDSM5Criteria([]);
            return;
        }
        ServerRequestProtected(API_URL_Patient + "/DSM5Criteria", 'post', {
            diagnosisCodeID,
            diagnosisCode
        }).then((response) => {
            const mapped = (response || [])
                .slice()
                .sort((a, b) => (a.DisplayOrder ?? 0) - (b.DisplayOrder ?? 0))
                .map(item => ({
                    ...item,
                    value: item.DSM5CriteriaID,
                    display: `${item.CriteriaText}`,
                }));
            setDsm5CriteriaOptions(mapped);
        }).catch((error) => {
            setDsm5CriteriaOptions([]);
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
        });
    }

    const handleDSM5CriteriaChange = (value) => {
        if (value === null || value === undefined || value === '') {
            setSelectedDSM5Criteria([]);
        } else {
            const selected = value?.['DSM5Criteria']
                ?.split(', ')
                .map(v => dsm5CriteriaOptions.find(item => String(item.value) === String(v)))
                .filter(Boolean);
            setSelectedDSM5Criteria(selected || []);
        }
    }

    return (
        <>
            {NewICDPopup}
            <Modal show={isOpenProblems} onHide={isOpenProblems} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems add_new-problem ar_new-popup-design">
                <Modal.Body>
                    {DeleteConfirmation}
                    {isLoading ? <Loader /> : null}
                    {/* <ModalHeader HeaderName={ProblemName} DeletePopup={''} isClosed={onClose} /> */}
                    <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={ProblemName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose}
                    // IsDeleteAllowed={props?.IsDeleteAllowed}
                    />
                    <div className="">
                        {console.log("mainProblemsModal", mainProblemsModal)}
                        {isEdit ?
                            <div className="input mb-12 claims_info search-icon-icdSearch">
                                <div className={`input form-group ${problemsValidationModal.DiagnosisCodeIDVal ? 'error' : ''}`}>
                                    {/* <SuperSearchList
                        type='server'
                        id='DiagnosisCodeID'
                        name='DiagnosisCodeID'
                        searchValue={mainProblemsModal.DiagnosisCodeID}
                        ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                        method='post'
                        postBody={problemsBody}
                        onChange={handleProblemsChange}
                        getSelectedData={handleSelectedData}
                        is={is}
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        icon={true}
                        disabled={true}
                        placeholder='Search existing problems here...'
                        inputError={problemsValidationModal.DiagnosisCodeIDVal}
                    /> */}
                                    {(mainProblemsModal.DiagnosisCode?.length > 0 && isProblemSelected) ?
                                        <i className='ar-cross-icon fs-18 icon-x-cros top-50 translate-middle-y top-50 translate-middle-y ar-light-color' onClick={handleClearDiagnosisCode}></i> : null}
                                    <div>
                                        <SuperICDandCPTSearch
                                            type='server'
                                            customData={RecentICDs}
                                            id='Dx'
                                            name='DiagnosisCode'
                                            onChange={handleProblemsChange}
                                            getSelectedData={handleSelectedData}
                                            is={is}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                            searchValue={mainProblemsModal.DiagnosisCode}
                                            searchBy={['display', 'Description']}
                                            tableData={[
                                                { columName: 'Code', bindingValue: 'display', },
                                                { columName: 'Description', bindingValue: 'Description', },
                                            ]}
                                            ApiLink={API_URL_Claim + "/ICDInstantSearch"}
                                            method='post'
                                            postBody={problemsBody}
                                            disabled={true}
                                            placeholder='Search existing problems here...'
                                            inputError={problemsValidationModal.DiagnosisCodeIDVal}
                                            isItemSelected={!isNull(mainProblemsModal.DiagnosisCode) ? true : false}
                                            handleAddNewCode={(searchValue, name) => handleAddNewICD(searchValue, name)}
                                        // handleAddNewCode={() => handleAddNewICD()}
                                        />
                                        {problemsValidationModal.DiagnosisCodeIDVal}
                                    </div>

                                </div>
                                {/* <div className='input-group hk-input-search'>
                        <input type="text" className='form-control'
                            placeholder='Search problem here...'
                        />
                        <span className="input-group-text seraches" id="basic-addon2">
                            <i className="bi bi-search"></i>
                        </span>
                    </div> */}
                            </div> : <>
                                {mainProblemsModal.DiagnosisCode &&
                                    <div className="mb-2 d-flex align-items-center justify-content-between gap-15 px-1">
                                        <p className="text fs-13 font-m ar-dark-color validation_message text-nowrap"> <span className='text-decoration-underline'>{mainProblemsModal.DiagnosisCode}
                                        </span> <span className=''>{mainProblemsModal.Description}</span></p>
                                        <i className='icon-edit-pencil fs-12' onClick={() => setIsEdit(prev => !prev)}></i>
                                    </div>}</>}
                        {isProblemSelected &&
                            <>
                                <div className="d-flex align-items-center gap-3 mb-12">
                                    <p className="text font-m fs-13">Acuity:</p>
                                    <div className="d-flex align-items-center gap-2">
                                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                                type="radio"
                                                id="Chronic"
                                                name="Acuity"
                                                value="Chronic"
                                                onChange={handleChange}
                                                checked={mainProblemsModal.Acuity === "Chronic"}
                                            />
                                            <label htmlFor="Chronic" className="text ar-orange-text pb-0">Chronic</label>
                                        </div>
                                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                                type="radio"
                                                id="Acute"
                                                name="Acuity"
                                                value="Acute"
                                                onChange={handleChange}
                                                checked={mainProblemsModal.Acuity === "Acute"}
                                            />
                                            <label htmlFor="Acute" className="text ar-orange-text pb-0">Acute</label>
                                        </div>
                                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                                type="radio"
                                                id="Undefined"
                                                name="Acuity"
                                                value="Undefined"
                                                onChange={handleChange}
                                                checked={mainProblemsModal.Acuity === "Undefined"}
                                            />
                                            <label htmlFor="Undefined" className="text ar-orange-text pb-0">Undefined</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-end gap-15 mb-12">
                                    {/* ${(problemsValidationModal.StartDateVal || error.DateVal) ? 'error' : ''} */}
                                    <div className={`input mb-0 ${(error.DateVal) ? 'error' : ''}`}>
                                        <DatePicker
                                            label="Start Date"
                                            className='mb-0'
                                            value={mainProblemsModal.StartDate}
                                            handleCalendarChangefunc={date => handleDateChange(date, 'StartDate')} />
                                        {error.DateVal}
                                    </div>
                                    <div className="input mb-0">
                                        <label className="pb-3px">End Date</label>
                                        <DatePicker
                                            value={mainProblemsModal.EndDate}
                                            handleCalendarChangefunc={date => handleDateChange(date, 'EndDate')} />
                                    </div>
                                    {/* <div className='d-flex align-items-center gap-6'>
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input p-0 m-0"
                                            name="IsEncounter"
                                            id="IsEncounter"
                                            checked={["true", true].includes(mainProblemsModal.IsEncounter) ? true : false}
                                            onChange={handleSetCheckbox}
                                        />
                                    </div>
                                    <p className='text font-m text-nowrap'>Associate with encounter</p>
                                </div> */}
                                    <div className='d-flex align-items-center gap-6'>
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input p-0 m-0"
                                                name="MarkAsPrimary"
                                                id="MarkAsPrimary"
                                                checked={mainProblemsModal.MarkAsPrimary === "true"}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <p className='text font-m text-nowrap'>Mark As Primary</p>
                                    </div>

                                </div>
                                <div className="input">
                                    <label className="pb-3px">Notes</label>
                                    <textarea
                                        rows="2"
                                        className="form-control"
                                        name="Notes"
                                        id="Notes"
                                        value={mainProblemsModal.Notes}
                                        onChange={handleChange}
                                    ></textarea>
                                </div>
                                {dsm5CriteriaOptions.length > 0 && (
                                    <div className="input">
                                        <label className="pb-3px">DSM-5 Diagnostic Criteria</label>
                                        <SuperSearchMultipleClient
                                            id="DSM5Criteria"
                                            name="DSM5Criteria"
                                            selectedOptionsDisplay='Criteria'
                                            options={dsm5CriteriaOptions}
                                            initialSelectedValues={selectedDSM5Criteria}
                                            searchParam={{ DSM5Criteria: selectedDSM5Criteria.map(x => x.value).join(', ') }}
                                            setSearchParam={handleDSM5CriteriaChange}
                                            sup_btn="sup_btn-Inp"
                                            sup_inp="superSearchVisitInp"
                                        />
                                    </div>
                                )}
                            </>}
                    </div>
                </Modal.Body>
                {/* <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 br-clr justify-content-end gap-2">
                <button className='btn btn-outline btn-xs no-width rounded-5 px-10' onClick={onClose}>Cancel</button>
                <div className="d-flex position-relative">
                    <button className='btn btn-validate btn-xs no-width ar_rounded rounded-5 px-10' onClick={handleSaveProblems}>Save</button>
                    <span className="clera_btn">
                        <i className={`icon-caret-${searchDropdown ? 'down' : 'up'} text-white cursor-pointer`} onClick={() => setSearchDropdown(!searchDropdown)}></i>
                        {searchDropdown &&
                            <div className="dropdown flex-column">
                                <div className="content  h-auto ">
                                    <p className="text text-nowrap cursor-pointer" onClick={() => handleSaveProblems("Add Another")}>Save & Add Another</p>
                                </div>
                            </div>

                        }
                    </span>
                </div>
            </div> */}
                <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
                    <button className='btn btn-outline  px-10 h-100 dark-clr ' onClick={onClose}>Cancel</button>
                    <div className="d-flex align-items-center gap-2">
                        <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveProblems("Add Another")}>Save & Add Another</button>
                        <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveProblems}>Save</button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddNewProblem